import { ModelBase } from 'store/model-base';
import { CmsQuickpayBreadcrumbs } from '../quickpay/quickpay-breadcrumbs';

export class CmsOneTimePayment extends ModelBase {
    public static storeName: string = 'cmsOneTimePayment';

    public review: CmsOneTimePaymentReview;
    public result: CmsOneTimePaymentResult;
    public header: string;
    public summary: CmsOneTimePaymentSummary;
    public start: CmsOneTimePaymentStart;
    public card: CmsOneTimePaymentCard;
    public cancelBtn: string;
    public reviewPaymentBtn: string;
    public progressBar: CmsQuickpayBreadcrumbs;
}
